import { useState } from 'react';
import { IoTriangle } from 'react-icons/io5';
import { TbTriangleInvertedFilled } from 'react-icons/tb';
import { ACTIVE_NETWORKS } from '@shared/utils/config/networks';
import { RiRefreshLine } from 'react-icons/ri';
import { CovalentBalanceItem } from '@shared/types/frontend';
import { toast } from 'sonner';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import { abbreviateNumber, toSpecialFixed } from '@/lib/misc/utils';
import NetworkDropdown from '@/components/shared/NetworkDropdown';
import classNames from '@/lib/misc/classNames';
import useLitSession from '../../hooks/LitSessionContext/useLitSession';
import { Drawer, DrawerContent, DrawerTrigger } from '@/components/ui/drawer';
import { CustomConnectButton } from '../shared/CustomConnectButton';
import Loading from '@/components/shared/Loading';
import AssetLogo from '../shared/AssetLogo';
import TruncatedText from './TruncatedText';
export default function CloudWalletBalance({
  confirm,
  wallet,
  selectedInputAssets,
  setSelectedInputAssets,
  showHeader = true,
  singleSelect = false,
  selectOne
}: {
  confirm?: () => void;
  wallet: string;
  solanaAddress?: string;
  showWallet?: boolean;
  showHeader?: boolean;
  copyAddress?: boolean;
  selectedInputAssets?: CovalentBalanceItem[];
  setSelectedInputAssets?: (x: CovalentBalanceItem[]) => void;
  singleSelect?: boolean;
  selectOne?: boolean;
}) {
  const {
    PKP
  } = useLitSession();
  const {
    data: cloudWalletBalance,
    refetch: refetchCloudWalletBalance,
    isFetching,
    isLoading
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress]
  });
  const defaultNetwork = ACTIVE_NETWORKS;
  const [network, setNetwork] = useState(defaultNetwork);
  if (!wallet) {
    return <div className='min-h-screen overflow-clip w-full flex items-center justify-center flex-col pb-32'>
        <div className='mb-4 text-lg'>Deposit From Wallet</div>
        <CustomConnectButton connectText='Connect Wallet' buttonClassName='w-full mt-4 lg:w-3/4 md:hover:bg-genius-pink bg-genius-purple md:hover:text-genius-indigo   text-genius-pink rounded-full transition-all duration-300 h-12 relative ' />
      </div>;
  }
  return <>
      {(isFetching || isLoading) && !cloudWalletBalance ? <div className='min-h-screen overflow-clip w-full flex items-center justify-center flex-col'>
          <Loading />
          <div className='mb-32 mt-4'>Loading Wallet Balances...</div>
        </div> : <>
          {' '}
          <div className={classNames(' text-gray-400 w-full  text-sm   transition-all duration-300 relative')}>
            {showHeader && <>
                {' '}
                <div className='flex justify-between items-center'>
                  <h3 className='mb-4 px-4'>
                    Balance: $
                    {cloudWalletBalance?.balancesByChain.reduce((acc, curr) => {
                return acc + curr?.totalUsdValue;
              }, 0)?.toFixed(2)}
                  </h3>
                </div>
                <div className='flex items-center gap-2 text-sm px-4 mb-4'>
                  <span>{wallet}</span>
                </div>
                <div className='mb-4 flex px-4 gap-4'>
                  <div onClick={() => {
              if (isLoading || isFetching) return;
              refetchCloudWalletBalance();
            }} className='underline hover:cursor-pointer hover:scale-105  '>
                    Refresh Balances
                  </div>
                  <Drawer>
                    <DrawerTrigger asChild>
                      <div className='underline hover:cursor-pointer hover:scale-105 mb-4'>
                        Switch Wallets
                      </div>
                    </DrawerTrigger>
                    <DrawerContent>
                      <div className='my-2 px-4 py-2 text-lg'>Switching Wallets</div>
                      <div className='flex flex-col p-4 pb-8'>
                        To switch wallets, navigate to your chrome extension or mobile wallet and
                        select the wallet you would like to use. Genius will automatically detect
                        the change.
                      </div>
                    </DrawerContent>
                  </Drawer>
                </div>
              </>}

            <div className={'flex items-center justify-between py-2 min-h-12 transition-all duration-200 text-genius-cream'}>
              <div className='w-full px-4 text-left flex items-start'>
                <NetworkDropdown setNetwork={setNetwork} network={network} defaultNetwork={defaultNetwork} isPortfolio={true} />
              </div>
              <div className='mr-4'>
                <RiRefreshLine onClick={() => {
              refetchCloudWalletBalance();
              toast.success('Refreshed Wallet Balances');
            }} />
              </div>
            </div>

            <div className='flex flex-col overflow-y-auto max-lg:h-[calc(100vh-144px)] h-[calc(100vh-100px)] no-scrollbar'>
              {cloudWalletBalance?.balances?.filter(x => x && x?.usd_value > 0)?.filter(x => network?.includes(x?.network)).length === 0 ? <div className='text-center text-gray-500 py-4'>
                  No balances available for the selected network.
                </div> : cloudWalletBalance?.balances?.filter(x => x && x?.usd_value > 0)?.filter(x => network?.includes(x?.network)).sort((a, b) => b.usd_value - a.usd_value).map((y, idx) => {
            return <div key={idx} onClick={() => {
              if (!setSelectedInputAssets) {
                return;
              }
              console.log('wefhoweiuf', singleSelect || selectOne);
              if (singleSelect || selectOne) {
                setSelectedInputAssets([{
                  ...y,
                  amountToUse: 0,
                  amountToUseStr: '0'
                }]);
              } else {
                setSelectedInputAssets(prev => {
                  const index = prev.findIndex(x => y.contract_address === x.contract_address && y.network === x.network);
                  console.log('prev index', index, prev, y);
                  if (index !== -1) {
                    return prev.filter((_, i) => i !== index);
                  } else {
                    return [...prev, {
                      ...y,
                      amountToUse: 0,
                      amountToUseStr: '0'
                    }];
                  }
                });
              }
              if (confirm) confirm();
            }} className={classNames('flex items-center justify-between py-2 h-[80px] transition-all duration-200 md:hover:bg-genius-blue cursor-pointer', selectedInputAssets?.find(z => z.contract_address === y.contract_address && z.network === y.network) ? 'bg-genius-blue/50' : '')}>
                        <div className='flex items-center gap-2 w-1/2 break-words pl-4'>
                          <div className='flex h-full shrink-0 relative items-center'>
                            <div className='lg:hidden'>
                              <AssetLogo asset={y} variant='table' size={5} truncate={true} showNetwork showName />
                            </div>
                            <div className='max-lg:hidden'>
                              <AssetLogo asset={y} variant='table' size={5} truncate={false} showNetwork showName />
                            </div>
                          </div>
                        </div>
                        <div className='flex flex-col pr-4 max-lg:hidden text-right w-32 items-end'>
                          <div className='flex items-center justify-end text-primary w-full'>
                            ${toSpecialFixed(y.quote_rate).value}
                          </div>
                          {y.quote_rate > y.quote_rate_24h ? <div className='flex flex-nowrap justify-end text-primary/50 w-full'>
                              <IoTriangle className='text-green-400' size={16} />
                              <p className='text-green-400'>
                                {((y.quote_rate - y.quote_rate_24h) / y.quote_rate_24h * 100)?.toFixed(2)}
                                %
                              </p>
                            </div> : <div className='flex flex-nowrap justify-end text-primary/50 w-full'>
                              <TbTriangleInvertedFilled className='text-red-400' size={16} />
                              <p className='text-red-400'>
                                {((y.quote_rate_24h - y.quote_rate) / y.quote_rate_24h * 100)?.toFixed(2)}
                                %
                              </p>
                            </div>}
                        </div>
                        <div className='flex flex-col pr-4 lg:w-1/4'>
                          <div className='flex items-center justify-end text-genius-cream'>
                            ${y.usd_value?.toFixed(2)}
                          </div>
                          <div className='flex flex-nowrap justify-end text-genius-cream/60 text-xs'>
                            {y.formatted_balance >= 1000000 ? abbreviateNumber(y.formatted_balance) : toSpecialFixed(y.formatted_balance).value}
                            <TruncatedText text={y.contract_ticker_symbol} className='ml-1' />
                          </div>
                        </div>
                      </div>;
          })}
            </div>
          </div>
        </>}
    </>;
}